import { Button, Text, Container, Title, Loader, Alert } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { verifyEmail } from "../openapi/api-client.ts";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IconAlertTriangle, IconLogin2 } from "@tabler/icons-react";
import { useForwardIfLoggedIn } from "../hooks/useForwardIfLoggedIn.ts";
import { CandidateContact } from "../components/CandidateContact.tsx";

export const VerifyEmail = () => {
  useForwardIfLoggedIn("/bewerbung");

  const verifyEmailMutation = useMutation({
    mutationFn: verifyEmail,
  });
  const { mutate: mutateVerifyEmail } = verifyEmailMutation;

  const [verified, setVerified] = useState<boolean>(false);
  const [fehler, setFehler] = useState<string | undefined>(undefined);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    mutateVerifyEmail(
      {
        emailVerificationToken: searchParams.get("token") ?? "",
      },
      {
        /*
          openapi-fetch wirft bei HTTP-Fehlern nicht, sondern liefert sie im
          Ergebnis — ohne diese Auswertung meldete die Seite auch bei einem
          ungueltigen Link Erfolg und schickte die Person zum Login, wo dann
          unerklaerlich nichts ging.
        */
        onSuccess: (response) => {
          if (response.response.ok) {
            setVerified(true);
            return;
          }

          if (response.response.status == 404) {
            setFehler(
              "Dieser Link ist nicht (mehr) gültig. Vielleicht hast du deine Adresse schon bestätigt — dann kannst du dich direkt einloggen.",
            );
            return;
          }

          setFehler(
            "Die Bestätigung hat nicht geklappt. Bitte versuch es später noch einmal.",
          );
        },
        onError: () => {
          setFehler(
            "Die Bestätigung hat nicht geklappt. Bitte versuch es später noch einmal.",
          );
        },
      },
    );
  }, [mutateVerifyEmail]);

  return (
    <Container my="lg">
      <Title mb="lg">E-Mail-Adresse bestätigen</Title>

      {verifyEmailMutation.isPending && (
        <Text>
          <Loader size="sm" /> E-Mail-Adresse wird bestätigt …
        </Text>
      )}

      {verified && (
        <>
          <Text mb="lg">
            Deine E-Mail-Adresse ist bestätigt. Du kannst dich jetzt einloggen
            und deine Mappe hochladen.
          </Text>
          <Button
            color="blue"
            size="lg"
            component={Link}
            to="/login"
            leftSection={<IconLogin2 />}
          >
            Zum Login
          </Button>
        </>
      )}

      {fehler && (
        <>
          <Alert
            color="red"
            mb="lg"
            icon={<IconAlertTriangle />}
            title="Bestätigung nicht möglich"
          >
            {/*
              Die Adresse steht als Komponente daneben, nicht im Meldungstext:
              sie kommt aus der Backend-Konfiguration und ist damit kein
              fester Bestandteil der Meldung mehr.
            */}
            {fehler} Wenn du nicht weiterkommst, wende dich an{" "}
            <CandidateContact />.
          </Alert>
          <Button
            color="blue"
            size="lg"
            component={Link}
            to="/login"
            leftSection={<IconLogin2 />}
          >
            Zum Login
          </Button>
        </>
      )}
    </Container>
  );
};

export default VerifyEmail;
